import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { supabase } from '@/integrations/supabase/client';

export function CodeInjection() {
  const [headerCode, setHeaderCode] = useState('');
  const [footerCode, setFooterCode] = useState('');

  useEffect(() => {
    const fetchCodeInjection = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('key, value')
          .in('key', ['header_code_injection', 'footer_code_injection']);

        if (error) throw error;

        data?.forEach((setting) => {
          if (setting.key === 'header_code_injection' && setting.value) {
            setHeaderCode(setting.value);
          } else if (setting.key === 'footer_code_injection' && setting.value) {
            setFooterCode(setting.value);
          }
        });
      } catch (error) {
        console.error('Error fetching code injection:', error);
      }
    };

    fetchCodeInjection();
  }, []);

  useEffect(() => {
    // Inject footer code
    if (footerCode) {
      const existingContainer = document.getElementById('footer-code-injection');
      if (existingContainer) {
        existingContainer.remove();
      }

      const container = document.createElement('div');
      container.id = 'footer-code-injection';
      container.innerHTML = footerCode;
      document.body.appendChild(container);

      // Execute any scripts in the footer code
      const scripts = container.querySelectorAll('script');
      scripts.forEach((oldScript) => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode?.replaceChild(newScript, oldScript);
      });

      return () => {
        const containerToRemove = document.getElementById('footer-code-injection');
        if (containerToRemove) {
          containerToRemove.remove();
        }
      };
    }
  }, [footerCode]);

  if (!headerCode) return null;

  return (
    <Helmet>
      {/* Inject header code using dangerouslySetInnerHTML equivalent for Helmet */}
      <script type="text/javascript">
        {`
          (function() {
            var headerCode = ${JSON.stringify(headerCode)};
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = headerCode;
            
            // Process and inject each element
            Array.from(tempDiv.children).forEach(function(el) {
              if (el.tagName === 'SCRIPT') {
                var script = document.createElement('script');
                Array.from(el.attributes).forEach(function(attr) {
                  script.setAttribute(attr.name, attr.value);
                });
                script.textContent = el.textContent;
                document.head.appendChild(script);
              } else {
                document.head.appendChild(el.cloneNode(true));
              }
            });
          })();
        `}
      </script>
    </Helmet>
  );
}
